import { FEATURE_TAB } from "@/v2-backoffice-client/feature/feature.constants"

/**
 * Operation name of basemap.query.gql (the Basemaps tab's table);
 * refetched by every mutation that adds a runtime row or flips a field the
 * table shows.
 */
export const BASEMAP_QUERY_NAME = "BasemapQuery"

/** Operation name of view/basemap.view.query.gql (the open basemap sheet). */
export const BASEMAP_VIEW_QUERY_NAME = "BasemapViewQuery"

/**
 * `id` of the basemap sheet's tab strip. The tab in view rides in the
 * `<id>-tab` search param (see components/tabs useTabParam), so a link can
 * open the sheet straight on the tab it means.
 */
export const BASEMAP_VIEW_TABS_ID = "basemap-view-tabs"

/** The tab the sheet opens on when the URL says nothing. */
export const BASEMAP_VIEW_DEFAULT_TAB = FEATURE_TAB.configuration

/**
 * Feature codes of runtime basemaps all start with this. The create form
 * seeds it so a new basemap is recognisable as one from its code alone,
 * the way MapLayer_ marks a map layer.
 */
export const BASEMAP_FEATURE_CODE_PREFIX = "Basemap_"

/** The layers page href that opens a basemap's view sheet. */
export function getBasemapSheetHref(featureCode: string): string {
  return `/layers?v=basemap:${encodeURIComponent(featureCode)}`
}
